import script from "./leak-summary-cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./leak-summary-cards.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__